import { GeoFence } from '../../domain/geoFence/GeoFence';
import { FlatProject } from '../../domain/project/FlatProject';
import { Project } from '../../domain/project/Project';
import { ProjectUser } from '../../domain/project/ProjectUser';
import { VehicleFlat } from '../../domain/vehicle/VehicleFlat';

export enum ProjectActionType {
  FETCH_PROJECTS_SUCCESS = `FETCH_PROJECTS_SUCCESS`,
  SET_ACTIVE_PROJECT = `SET_ACTIVE_PROJECT`,
  PROJECTS_CREATE_PROJECT_SUCCESS = `PROJECTS_CREATE_PROJECT_SUCCESS`,
  PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS = `PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS`,
  SEARCH_FLAT_VEHICLES_SUCCESS = `SEARCH_FLAT_VEHICLES_SUCCESS`,
  RESET_PROJECT = `RESET_PROJECT`,
  FETCH_PROJECT_USERS_SUCCESS = `FETCH_PROJECT_USERS_SUCCESS`,
  FETCH_PROJECT_GEOFENCES_SUCCESS = `FETCH_PROJECT_GEOFENCES_SUCCESS`,
}

export interface FetchProjectsSuccessAction {
  type: ProjectActionType.FETCH_PROJECTS_SUCCESS;
  payload: {
    flatProjects: FlatProject[];
  };
}

export interface SetActiveProjectAction {
  type: ProjectActionType.SET_ACTIVE_PROJECT;
  payload: {
    activeProject: Project;
  };
}

export interface ProjectsCreateProjectSuccessAction {
  type: ProjectActionType.PROJECTS_CREATE_PROJECT_SUCCESS;
  payload: {
    project: Project;
  };
}

export interface ProjectsEditProjectsResourcesSuccessAction {
  type: ProjectActionType.PROJECTS_EDIT_PROJECTS_RESOURCES_SUCCESS;
  payload: {
    projects: Array<Project>;
  };
}

export interface SearchFlatVehiclesSuccessAction {
  type: ProjectActionType.SEARCH_FLAT_VEHICLES_SUCCESS;
  payload: {
    flatVehicles: Array<VehicleFlat>;
  };
}

export interface FetchProjectUsersSuccessAction {
  type: ProjectActionType.FETCH_PROJECT_USERS_SUCCESS;
  payload: {
    users: Array<ProjectUser>;
  };
}

export interface FetchProjectGeofencesSuccessAction {
  type: ProjectActionType.FETCH_PROJECT_GEOFENCES_SUCCESS;
  payload: {
    geoFences: Array<GeoFence>;
  };
}

export interface ResetProjectAction {
  type: ProjectActionType.RESET_PROJECT;
}

export type ProjectActions =
  | FetchProjectsSuccessAction
  | SetActiveProjectAction
  | ProjectsCreateProjectSuccessAction
  | ProjectsEditProjectsResourcesSuccessAction
  | SearchFlatVehiclesSuccessAction
  | ResetProjectAction
  | FetchProjectUsersSuccessAction
  | FetchProjectGeofencesSuccessAction;
